<div class="post-group-holder" *ngFor="let group of postGroups; trackBy: trackByGroup">
	<div class="post-group-title" *ngIf="group.posts.length > 0">{{group.text}}</div>
	<div class="qo-card post-holder" *ngFor="let bulletinBoardPost of group.posts; trackBy: trackById">
		<div class="post-info-holder">
			<div class="post-header">
				<div class="qo-flex-row">
					<qo-profile-image
						class="qo-margin-right20"
						[letter]="bulletinBoardPost.user.getInitials()"
						[imageUrl]="bulletinBoardPost.user.profile_picture?.download_url"
						[size]="32"
						[fontSize]="20"
					></qo-profile-image>
					<div class="qo-flex-col">
						<div>{{bulletinBoardPost.user.getFullName()}}</div>
						<div>{{bulletinBoardPost.updated_at.format('short')}}</div>
					</div>
				</div>


				<div class="actions">
					<div
						class="post-seen-by bold"
						(click)="postSeenByInfo(bulletinBoardPost)"
					>
						{{ 'MESSAGE_BOARD.SEEN_BY' | translate }}
						{{bulletinBoardPost.seen_by_count === 0 ? ('MESSAGE_BOARD.NOONE'  | translate) : bulletinBoardPost.seen_by_count}}
					</div>

					<div class="post-action">
						<qo-input-dropdown
							[icon]="EQORebrandIcon.more_dark"
							[invertedScheme]="true"
							[scheme]="EQORebrandColor.SECONDARY"
							[compact]="true"
							[border]="false"
							[actions]="[
            {rebrandIcon: EQORebrandIcon.edit_dark, clickValue: bulletinBoardPost, onClick: editPost, text: 'MESSAGE_BOARD.EDIT_POST' | translate, disabled: !(user$ | async) || bulletinBoardPost.user.id != (user$ | async).id},
            {rebrandIcon: EQORebrandIcon.info_dark, clickValue: bulletinBoardPost, onClick: postSeenByInfo, text: 'MESSAGE_BOARD.SEEN_BY' | translate},
             {rebrandIcon: EQORebrandIcon.trash_dark, clickValue: bulletinBoardPost, onClick: deletePost, text: 'MESSAGE_BOARD.REMOVE_POST' | translate, disabled: !(user$ | async) || bulletinBoardPost.user.id != (user$ | async).id}
          ]"
							[size]="'small'"
						></qo-input-dropdown>
					</div>
				</div>
			</div>
			<div
				class="post-content-text"
				[innerHTML]="bulletinBoardPost.content | linkify"
			></div>
			<div class="file-holder" style="max-width: 200px">
				<app-file-entry-edit
					[fileEntries]="bulletinBoardPost.file_entries"
					[edit]="false"
				>
				</app-file-entry-edit>
			</div>
			<div *ngIf="showButtons">
				<div class="social">
					<qo-icon
						[icon]="bulletinBoardPost.liked ? EQORebrandIcon.heart_dark : EQORebrandIcon.heart_dark_filled"
						[invertedScheme]="true"
						[scheme]="EQORebrandColor.SECONDARY"
						[color]="EQORebrandColor.SECONDARY"
						[size]="'sm'"
						(click)="likeOrDislikePost(bulletinBoardPost)"
						[clickable]="true"
					></qo-icon>
					<div [ngClass]="authService.windowWidth < 800 ? 'mobile-likes': 'likes-and-comments'">
						<div
							class="likes"
							(click)="postLikedByInfo([bulletinBoardPost])">
							<div>
								<qo-overlapping-oval-icons
									[overlappingIcons]="bulletinBoardPost.overlappingLikeIcons"
									[stackMargin]="5"
									[iconsPadding]="7"
									[baseIcon]="bulletinBoardPost.message_board_post_likes_count > 4 ? ICON.PLUS_GREY3 : ICON.NONE"
								></qo-overlapping-oval-icons>
							</div>
							<div class="number-of-likes">
								{{ bulletinBoardPost.message_board_post_likes_count | i18nPlural: {
								'=0': 'MESSAGE_BOARD.LIKES.NONE',
								'=1': 'MESSAGE_BOARD.LIKES.SINGLE',
								'other': 'MESSAGE_BOARD.LIKES.PLUR'
							} | translate:{x: bulletinBoardPost.message_board_post_likes_count} }}
							</div>
						</div>

						<div class="comments">
							<qo-icon
								[icon]="EQORebrandIcon.chat_dark"
								[invertedScheme]="true"
								[scheme]="EQORebrandColor.SECONDARY"
								[color]="EQORebrandColor.SECONDARY"
								[size]="'sm'"
							></qo-icon>
							<div class="number-of-comments">
								{{ bulletinBoardPost.message_board_post_comments_count | i18nPlural: {
								'=0': 'MESSAGE_BOARD.COMMENTS.NONE',
								'=1': 'MESSAGE_BOARD.COMMENTS.SINGLE',
								'other': 'MESSAGE_BOARD.COMMENTS.PLUR'
							} | translate:{x: bulletinBoardPost.message_board_post_comments_count} }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div [ngClass]="authService.windowWidth < 800 ? 'new-comment-mobile-view' : 'new-comment'">
				<div>
					<qo-profile-image
						[letter]="(user$ | async).getInitials()"
						[imageUrl]="(user$ | async)?.profile_picture?.download_url"
						[size]="60"
						[fontSize]="26"
					></qo-profile-image>
				</div>
				<div class="comment-area">
					<form [formGroup]="form">
							<textarea
								data-cy="new-post-comment-textarea"
								class="qo-input"
								[placeholder]="'MESSAGE_BOARD.YOUR_COMMENT' | translate"
								(keydown.space)="bulletinBoardPost.comment = emojify.transform(bulletinBoardPost.comment)"
								(keydown.dot)="bulletinBoardPost.comment = emojify.transform(bulletinBoardPost.comment)"
								formControlName="comment"
							>
							</textarea>
					</form>
				</div>
				<div>
					<button
						class="qo-button-standard qo-primary send-comment-button"
						data-cy="save-post-comment-btn"
						(click)="createComment(bulletinBoardPost)"
						[disabled]="form.invalid">{{ 'MESSAGE_BOARD.SEND' | translate}}
					</button>
				</div>
			</div>
		</div>
		<div class="line-breaker"></div>
		<div class="all-comments">
			<div class="comment-holder" *ngFor="let comment of bulletinBoardPost.comments; let i = index; trackBy:trackById">
				<div class="comment-holder-comment-data">
					<div class="comment-holder-profile">
						<qo-profile-image
							[letter]="comment.user.getInitials()"
							[imageUrl]="comment.user.profile_picture?.download_url"
							[size]="40"
							[fontSize]="20"
						></qo-profile-image>
						<div class="comment-holder-profile-name-and-text">
							<div class="name-time-holder">
								<div class="name-time">
									<div class="name">{{comment.user.getFullName()}}</div>
									<div class="comment-holder-info-date bold">
										{{comment.created_at.format('short')}}
									</div>
								</div>
								<div class="comment-holder-right-side">

									<div class="comment-edit-icon" *ngIf="comment.user.id === authService.currentUser.id">
										<qo-input-dropdown
											[icon]="EQORebrandIcon.more_dark"
											[invertedScheme]="true"
											[scheme]="EQORebrandColor.SECONDARY"
											[compact]="true"
											[border]="false"
											[actions]="[
                        {rebrandIcon: EQORebrandIcon.edit_dark, clickValue: [bulletinBoardPost, comment], onClick: editComment, text: 'BULLETINBOARD.EDIT_COMMENT' | translate},
                        {rebrandIcon: EQORebrandIcon.trash_dark, clickValue: [bulletinBoardPost, comment], onClick: deleteComment, text: 'BULLETINBOARD.DELETE_COMMENT' | translate}
                      ]"
											[size]="'small'"
										></qo-input-dropdown>
									</div>
								</div>

							</div>
							<div
								class="comment-text"
								[innerHTML]="comment.comment | linkify"
							></div>
						</div>
					</div>
				</div>
				<div class="line-breaker" *ngIf="i < bulletinBoardPost.comments.length -1"></div>
			</div>

			<div
				class="load-more-comments"
				*ngIf="bulletinBoardPost.message_board_post_comments_count > bulletinBoardPost.comments.length && bulletinBoardPost.message_board_post_comments_count > 1">
				<button
					class="qo-button-small qo-secondary-invert"
					(click)="getMoreComments(bulletinBoardPost)"
				>
					{{ 'MESSAGE_BOARD.LOAD_MORE_COMMENTS' | translate}}</button>
			</div>
		</div>
	</div>
</div>

